import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 4000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-2.5 left-2.5 z-50 max-w-[15.5rem] sm:left-3 sm:bottom-3" data-id="element-158" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-159" data-mp="117o3xw84v33l">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-lg border-2 border-gold bg-white p-2 shadow-xl shadow-brand-deep/30 ring-2 ring-alert" data-id="element-160" data-mp="1fvspr92hfuql">
            <span className="mt-px flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-alert" data-id="element-161" data-mp="x6c99caejroj">
              <CheckIcon size={12} strokeWidth={4} className="text-white" aria-hidden="true" data-id="element-162" data-mp="s4myzyv07i1i" />
            </span>
            <div className="min-w-0" data-id="element-163" data-mp="28imxr6i451n6">
              <p className="text-[0.68rem] font-extrabold leading-tight text-brand-dark" data-id="element-164" data-mp="23lmz3gnlf163">
                {buyer.name} compró el Mega Pack
              </p>
              <p className="mt-0.5 flex items-start gap-1 text-[0.62rem] font-semibold leading-tight text-ink-muted" data-id="element-165" data-mp="2aobgkvh5af07">
                <MapPinIcon size={10} className="mt-px flex-shrink-0 text-brand" aria-hidden="true" data-id="element-166" data-mp="2fphauxqgeabu" />
                {buyer.city}, Argentina · hace {buyer.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="-mr-0.5 -mt-0.5 flex-shrink-0 rounded p-0.5 text-ink-muted transition-colors duration-150 ease-soft hover:text-alert" data-id="element-167" data-mp="1rzmui66xe3mu">
              <XIcon size={12} strokeWidth={3} aria-hidden="true" data-id="element-168" data-mp="26oj1dzx8xalv" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}